export default __webpack_public_path__ + "static/do-length-eb2ee19a5fd2fb57d4c7d250fb3bdf4e.png";